const initialstate = {
    data:[],
    viewdata:[],
    applydata:[],
    rejectdata:[],
    docdata:[],
}

const OrgAppApplications =  (state = initialstate, action:any)=>{
    switch (action.type){
        case 'fetch_data_success':
            return {... state, data:action.payload};
            case 'FETCH_VIEW_DATA_SUCCESS':
                return {... state, viewdata:action.payload};
                case 'APPLY_DATA_SUCCESS':
                return {... state, applydata:action.payload};
                case 'Reject_DATA_SUCCESS':
                return {... state, rejectdata:action.payload};
                case 'VIEW_DATA_SUCCESS':
                return {... state, docdata:action.payload};
            default :
            return state;
    }
};
export default OrgAppApplications;